(async () => {
    const { Core } = await importModule('Core');
    customElements.define('product-options-dropdown', class extends Core {
        elements = { dropdown: 'drop-down', current: '[data-current]' }

        render() {
            this.syncNativeOptions();
            if (!this._boundChange) {
                this._boundChange = this._onChange.bind(this);
                this.addEventListener('change', this._boundChange);
            }
        }

        availableRadios() {
            return Array.from(this.querySelectorAll('input[type="radio"]')).filter(radio => {
                const row = radio.closest('label') || radio;
                const menu = row.closest('[data-menu]');
                const measurable = !menu || menu.offsetParent !== null;
                if (measurable && row.offsetParent === null) return false;
                return !radio.disabled && !row.hidden && getComputedStyle(row).display !== 'none' && row.getAttribute('aria-hidden') !== 'true';
            });
        }

        syncNativeOptions() {
            const select = this.querySelector('select');
            if (!select) return;
            const radios = this.availableRadios();
            const options = Array.from(select.options);
            if (options.length !== radios.length || options.some((option, i) => option.value !== radios[i].value)) {
                select.replaceChildren(...radios.map(radio => new Option(radio.value, radio.value, radio.checked, radio.checked)));
            }
            const selected = radios.find(radio => radio.checked);
            select.selectedIndex = selected ? radios.indexOf(selected) : -1;
        }

        _onChange(event) {
            const { target } = event;
            if (target.tagName === 'SELECT') {
                event.stopPropagation();
                const radio = this.availableRadios().find(input => input.value === target.value);
                if (radio) radio.click();
                else this.syncNativeOptions();
                return;
            }
            if (!target.matches('input[type="radio"]')) return;
            this.syncNativeOptions();
            this.$current.textContent = target.value;
            this.$dropdown.close();
        }
    });
})();
